var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74967 1.4165H6.62467C5.68537 1.4165 4.78453 1.78964 4.12034 2.45383C3.45615 3.11803 3.08301 4.01886 3.08301 4.95817V7.08317H0.958008V9.9165H3.08301V15.5832H5.91634V9.9165H8.04134L8.74967 7.08317H5.91634V4.95817C5.91634 4.77031 5.99097 4.59014 6.12381 4.4573C6.25665 4.32447 6.43681 4.24984 6.62467 4.24984H8.74967V1.4165Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f400d16248b242976d0a4ff421603675.svg";
export { ForwardRef as ReactComponent };